


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({name: 'c-spf-show-modal'})
export default class CBudgetShowSpfModal extends Vue {
    private showModal = false;

    private dataArr: any[] = [];
    private titleYear: string = '';

    private progress = 0;
    private totalSum = 0;

     // ---- переводы
     private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: {
                val0: this.getBudgetText('sum_calc_abp.gulvl_modal.title.val0'), // Детализация
                val1: this.getBudgetText('sum_calc_abp.gulvl_modal.title.val1') // г.
            },
            gu: this.getBudgetText('sum_calc_gu.gu'), // ГУ
            sum: this.getBudgetText('sum_calc_abp.gulvl_modal.sum'), // СУММА ТЫС. ТЕҢГЕ
            total: this.getBudgetText('sum_calc_abp.gulvl_modal.total'), // Итого
        }
        return obj;
    }

    private showEvent(params: any) {
        this.progress = 0;
        this.showModal = true;
        this.loadData(params);
    }

    private async loadData(params: any) {
        this.progress = 60;
        this.totalSum = 0;
        try {
            const result = await fetch('/api-py/get-budget-events-gu-abp-for-uo-detail/' + JSON.stringify(params));
            if (result.status === 200) {
                const json = await result.json();
                for (const el of json) {
                    this.totalSum += el.abp_value;
                }
                this.dataArr = json;
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-events-gu-abp-for-uo-detail', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-budget-events-gu-abp-for-uo-detail', (error as Error).toString());
        } finally {
            this.progress = 100
        }
    }
}
